module.exports = __webpack_public_path__ + "static/media/10.444de1d2.jpg";